export default __webpack_public_path__ + "static/media/start-quiz.44b4fcb3.png";